import { ChangeUserPasswordResult } from '../../../core/services/user-settings.service';

export enum PasswordChangeStatus {
  InputForm = 1,
  Changing,
  Changed,
  ChangeFailed
}

export interface UserPasswordState {
  changeStatus: PasswordChangeStatus;
  changeFailureResult?: ChangeUserPasswordResult;
}

export const initialState: UserPasswordState = {
  changeStatus: PasswordChangeStatus.InputForm
};
